const API_BASE = process.env.REACT_APP_API_URL || "";

export type TmaDeliveryOption = {
  id: string;
  serviceCode: string;
  basicServiceCode: string;
  type: "home" | "service_point" | "parcel_locker" | "store_pickup";
  title: string;
  description?: string;
  weightClass?: "normal" | "light" | "any";
  allowsExpress?: boolean;
  currency: string;
  listPriceOre?: number;
  listPrice?: number;
  priceOre: number;
  price: number;
  freeShippingApplied?: boolean;
  freeShippingPriceOre?: number;
  requiresServicePoint: boolean;
  servicePointType: "service_point" | "locker" | null;
  additionalServiceCodes: string[];
};

export type TmaExpressAddon = {
  title: string;
  description?: string;
  listPriceOre?: number;
  listPrice?: number;
  priceOre: number;
  price: number;
  additionalServiceCodes?: string[];
};

export type TmaServicePoint = {
  id: string;
  name: string;
  type: "service_point" | "locker" | "unknown";
  street?: string;
  postalCode?: string;
  city?: string;
  countryCode?: string;
  distanceMeters?: number;
};

export async function fetchTmaStatus(): Promise<{ enabled: boolean }> {
  const res = await fetch(`${API_BASE}/api/tma/status`);
  if (!res.ok) return { enabled: false };
  const data = await res.json();
  return { enabled: Boolean(data.enabled) };
}

export async function fetchDeliveryOptions(input: {
  postalCode: string;
  country?: string;
  weightGrams?: number;
  /** Varukorgens summa i SEK — styr fri-frakt-pris */
  cartTotalSek?: number;
}): Promise<{
  options: TmaDeliveryOption[];
  expressAddon?: TmaExpressAddon | null;
  freeShippingReached?: boolean;
  freeShippingThreshold?: number;
}> {
  const qs = new URLSearchParams({
    postalCode: input.postalCode.replace(/\s+/g, ""),
    country: input.country || "SE",
  });
  if (input.weightGrams) qs.set("weightGrams", String(input.weightGrams));
  if (
    input.cartTotalSek !== undefined &&
    Number.isFinite(input.cartTotalSek)
  ) {
    qs.set("cartTotalSek", String(input.cartTotalSek));
  }
  const res = await fetch(`${API_BASE}/api/tma/delivery-options?${qs}`);
  const data = await res.json();
  if (!res.ok || !data.ok) {
    throw new Error(data.error || "Kunde inte hämta fraktalternativ");
  }
  return {
    options: Array.isArray(data.options) ? data.options : [],
    expressAddon: data.expressAddon || null,
    freeShippingReached: Boolean(data.freeShippingReached),
    freeShippingThreshold: data.freeShippingThreshold,
  };
}

export async function fetchServicePoints(input: {
  postalCode: string;
  type?: "service_point" | "locker" | "all";
  country?: string;
  city?: string;
}): Promise<TmaServicePoint[]> {
  const qs = new URLSearchParams({
    postalCode: input.postalCode.replace(/\s+/g, ""),
    country: input.country || "SE",
    type: input.type || "all",
  });
  if (input.city) qs.set("city", input.city);
  const res = await fetch(`${API_BASE}/api/tma/service-points?${qs}`);
  const data = await res.json();
  if (!res.ok || !data.ok) {
    throw new Error(data.error || "Kunde inte hämta utlämningsställen");
  }
  return Array.isArray(data.servicePoints) ? data.servicePoints : [];
}
